export default __webpack_public_path__ + "static/media/burger-menu.8284aafe.svg";